import { Stack } from 'components/Stack'
import { ReviewRoot } from './Review.styles'
import Image from 'next/dist/client/image'
import isotype from '/public/assets/isotype-line.svg'
import { Text } from 'components/Text'

type ReviewProps = {
  name: string
  headline: string
  content: string
}

export const Review = ({ name, headline, content }: ReviewProps) => {
  return (
    <ReviewRoot>
      <Stack gap="2" direction="column">
        <Stack gap="2" alignItems="center">
          <Image src={isotype} alt="" width={64} height={64} />
          <Text size="headline" weight="medium" align="center">
            {name}
          </Text>
        </Stack>
        <Stack direction="column">
          <Text size="h5" weight="medium">
            {headline}
          </Text>
          <Text>“{content}”</Text>
        </Stack>
      </Stack>
    </ReviewRoot>
  )
}
